import AuthService from 'src/services/AuthService';
import {
    clearAuthState,
    isFetchingUpdate,
    setAuthState,
} from './dispatchActions';
import { fireTracking } from 'src/utils/tracking';
import CookieStore from 'src/utils/cookie';
import { COOKIE_KEY } from 'src/constants';

export function auth() {
    return (dispatch: any) => {
        dispatch(isFetchingUpdate(true));
        AuthService.auth()
            .then((resp) => {
                if (resp.data) {
                    (window as any).dataAuth = resp.data;
                    dispatch(setAuthState(resp.data));
                    const isClickBtn = CookieStore.get(
                        COOKIE_KEY.BM_CLICK_LOGIN
                    ) as boolean;
                    if (resp.data.userId > 0 && isClickBtn) {
                        fireTracking('/log', {
                            key: 'wap_consent_privacy',
                            uid: resp.data.strUserId,
                        });
                        fireTracking('/log', {
                            key: 'wap_consent_tou',
                            uid: resp.data.strUserId,
                        });
                        CookieStore.remove(COOKIE_KEY.BM_CLICK_LOGIN);
                    }
                }
            })
            .finally(() => {
                dispatch(isFetchingUpdate(false));
            });
    };
}

export function login() {
    return (dispatch: any) => {
        dispatch(isFetchingUpdate(true));
        AuthService.auth()
            .then((resp) => {
                if (resp.data) {
                    dispatch(setAuthState(resp.data));
                }
            })
            .finally(() => {
                dispatch(isFetchingUpdate(false));
            });
    };
}

export function logout() {
    return (dispatch: any) => {
        dispatch(isFetchingUpdate(true));
        AuthService.logout()
            .then((resp) => {
                window.location.replace(window.location.href);
                if (resp.data) {
                    setTimeout(() => {
                        dispatch(clearAuthState());
                    }, 100);
                }
            })
            .finally(() => {
                dispatch(isFetchingUpdate(false));
            });
    };
}
